<div
  class="json-editor"
  [class.json-editor--altura-automatica]="isEditavel && autoAjustarAltura"
  [style.height]="isEditavel ? obterAltura() : 'auto'">
  <div class="json-editor__header">
    <span class="json-editor__title">&#123; &#125; {{ label }}</span>
    <div class="json-editor__acoes">
      @if (isEditavel) {
        <button type="button" class="json-editor__botao" matTooltip="Formatar JSON" (click)="formatar()">
          <mat-icon class="material-icons">auto_fix_high</mat-icon>
        </button>
      }
      <button type="button" class="json-editor__botao" matTooltip="Copiar JSON" (click)="copiar()">
        <mat-icon class="material-icons">content_copy</mat-icon>
      </button>
    </div>
  </div>

  <div class="json-editor__corpo">
    <div class="json-editor__gutter" #gutter>
      @for (linha of linhasNumeros(); track linha) {
        <span>{{ linha }}</span>
      }
    </div>

    @if (isEditavel) {
      <textarea
        #editor
        class="json-editor__textarea"
        [class.json-editor__textarea--erro]="erro()"
        spellcheck="false"
        autocomplete="off"
        [placeholder]="placeholder"
        [value]="texto()"
        (input)="aoDigitar($event)"
        (keydown)="aoPressionarTecla($event)"
        (focus)="registrarCursor($event)"
        (click)="registrarCursor($event)"
        (keyup)="registrarCursor($event)"
        (select)="registrarCursor($event)"
        (scroll)="sincronizarScroll($event, gutter)"
        (blur)="validar(false)">
      </textarea>
    } @else {
      <div class="json-editor__codigo" (scroll)="sincronizarScroll($event, gutter)">
        @for (linha of linhasTokenizadas(); track $index) {
          <div class="json-linha">
            @for (t of linha; track $index) {
              <span [class]="t.classe">{{ t.valor }}</span>
            }
          </div>
        }
      </div>
    }
  </div>

  @if (isEditavel && erro()) {
    <div class="json-editor__erro">{{ erro() }}</div>
  }
</div>
